// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1eZ5rdeLzQfz7Py2oIMbEL","table":"_1WYzW8WvDl03I6_kDlkKx8"};